import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { IconNone } from '@zoom/icons-react'
import { updateArtisticStyle, updateSpace } from './actions'
import { SPACE_OPTIONS, STYLE_OPTIONS } from './constants'
import { selectArtisticStyle, selectQuery, selectSpace } from './reducer'
import './NewPresetsMobile.css'

const NewPresetsMobile = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const selectedStyle = useSelector(selectArtisticStyle)
  const query = useSelector(selectQuery)
  const selectedSpaceId = useSelector(selectSpace)
  const trimmedQuery = query?.trim()
  const hasStyleInput = Boolean(selectedSpaceId || trimmedQuery)
  const selectedSpace = SPACE_OPTIONS.find(
    (option) => option.id === selectedSpaceId
  )
  const selectedStyleOption = STYLE_OPTIONS.find(
    (option) => option.value === selectedStyle
  )

  useEffect(() => {
    if (!hasStyleInput && selectedStyle) {
      dispatch(updateArtisticStyle(null))
    }
  }, [dispatch, hasStyleInput, selectedStyle])

  const handleSelectSpace = (option) => {
    const nextSpaceId = selectedSpaceId === option.id ? null : option.id
    dispatch(updateSpace(nextSpaceId))

    if (!nextSpaceId && !trimmedQuery) {
      dispatch(updateArtisticStyle(null))
    }
  }

  const handleSelectStyle = (styleOption) => {
    if (!hasStyleInput) return

    const nextStyle =
      selectedStyle === styleOption.value ? null : styleOption.value

    dispatch(updateArtisticStyle(nextStyle))
  }

  return (
    <div className="new-presets-mobile">
      <div className="new-presets-mobile-section">
        <p className="new-presets-mobile-title">{t('Select a space')}</p>
        {selectedSpace ? (
          <div className="new-presets-mobile-selected-space">
            <button
              className="new-presets-mobile-chip selected space"
              onClick={() => handleSelectSpace(selectedSpace)}
              type="button"
            >
              <img
                className="new-presets-mobile-chip-thumb"
                src={selectedSpace.thumbnail}
                alt=""
                aria-hidden="true"
              />
              <span className="new-presets-mobile-chip-label">
                {t(selectedSpace.label)}
              </span>
              <span
                className="new-presets-mobile-chip-clear"
                aria-hidden="true"
              >
                ×
              </span>
            </button>
          </div>
        ) : (
          <div className="new-presets-mobile-row" role="list">
            {SPACE_OPTIONS.map((option) => {
              const isSelected = selectedSpaceId === option.id

              return (
                <button
                  key={option.id}
                  className={`new-presets-mobile-chip space ${
                    isSelected ? 'selected' : ''
                  }`}
                  onClick={() => handleSelectSpace(option)}
                  type="button"
                  role="listitem"
                >
                  <img
                    className="new-presets-mobile-chip-thumb"
                    src={option.thumbnail}
                    alt=""
                    aria-hidden="true"
                  />
                  <span className="new-presets-mobile-chip-label">
                    {t(option.label)}
                  </span>
                </button>
              )
            })}
          </div>
        )}
      </div>

      <div className="new-presets-mobile-section">
        <p className="new-presets-mobile-title">{t('Style (optional)')}</p>
        {selectedStyleOption ? (
          <div className="new-presets-mobile-selected-space">
            <button
              className="new-presets-mobile-chip selected style"
              onClick={() => dispatch(updateArtisticStyle(null))}
              type="button"
              disabled={!hasStyleInput}
            >
              <img
                className="new-presets-mobile-chip-thumb"
                src={selectedStyleOption.thumbnail}
                alt=""
                aria-hidden="true"
              />
              <span className="new-presets-mobile-chip-label">
                {t(selectedStyleOption.value)}
              </span>
              <span
                className="new-presets-mobile-chip-clear"
                aria-hidden="true"
              >
                ×
              </span>
            </button>
          </div>
        ) : (
          <div className="new-presets-mobile-row" role="list">
            <button
              className={`new-presets-mobile-chip style ${
                !selectedStyle ? 'selected' : ''
              } ${!hasStyleInput ? 'disabled' : ''}`}
              onClick={() => {
                if (!hasStyleInput) return
                dispatch(updateArtisticStyle(null))
              }}
              type="button"
              role="listitem"
              disabled={!hasStyleInput}
            >
              <span className="new-presets-mobile-none-icon" aria-hidden="true">
                <IconNone />
              </span>
              <span className="new-presets-mobile-chip-label">{t('None')}</span>
            </button>
            {STYLE_OPTIONS.map((option) => {
              const isSelected = selectedStyle === option.value
              return (
                <button
                  key={option.value}
                  className={`new-presets-mobile-chip style ${
                    isSelected ? 'selected' : ''
                  } ${!hasStyleInput ? 'disabled' : ''}`}
                  onClick={() => handleSelectStyle(option)}
                  type="button"
                  role="listitem"
                  disabled={!hasStyleInput}
                >
                  <img
                    className="new-presets-mobile-chip-thumb"
                    src={option.thumbnail}
                    alt=""
                    aria-hidden="true"
                  />
                  <span className="new-presets-mobile-chip-label">
                    {t(option.value)}
                  </span>
                </button>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default NewPresetsMobile
